import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HashLink } from 'react-router-hash-link';
import { Play } from 'lucide-react';
import { SHOWREEL_VIDEO } from '../../data';

const Menu = ({ isOpen, onClose, onVideoClick }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                    className="fixed inset-0 z-40 bg-[#050505] flex flex-col md:flex-row"
                >
                    <div className="w-full md:w-1/2 p-6 md:p-12 flex flex-col justify-center md:justify-between border-r border-white/10 h-full">
                        <div className="space-y-4 md:space-y-2">
                            {['Home', 'Work', 'About', 'Services'].map((item, i) => {
                                const isAbout = item === 'About';
                                const path = isAbout ? '/about' : `/#${item.toLowerCase()}`;

                                return (
                                    <HashLink
                                        key={item}
                                        to={path}
                                        smooth={!isAbout}
                                        initial={{ x: -50, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        transition={{ delay: 0.1 * i }}
                                        onClick={onClose}
                                        className="block font-migra text-5xl md:text-7xl hover:italic hover:pl-4 transition-all duration-300 cursor-pointer"
                                    >
                                        {item}
                                    </HashLink>
                                );
                            })}
                        </div>
                        <div className="mt-12 md:mt-0 space-y-4 text-xs uppercase tracking-[0.2em] text-white/50">
                            <p>Based in Indonesia</p>
                            <p>Serving Worldwide</p>
                            <p>GMT+7</p>
                        </div>
                    </div>

                    <div className="hidden md:flex w-1/2 p-12 flex-col justify-center items-center bg-[#111]">
                        <div className="w-full max-w-md aspect-video relative group cursor-pointer overflow-hidden rounded-sm" onClick={onVideoClick}>
                            <video src={SHOWREEL_VIDEO} autoPlay muted loop className="w-full h-full object-cover opacity-60 group-hover:opacity-100 transition-opacity duration-500" />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-16 h-16 rounded-full border border-white/30 flex items-center justify-center backdrop-blur-md group-hover:scale-110 transition-transform">
                                    <Play fill="white" size={20} />
                                </div>
                            </div>
                        </div>
                        <p className="mt-8 text-xs uppercase tracking-widest opacity-50">Watch Showreel (2025)</p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
export default Menu;
